import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import { IconName, Icon, Typo } from '@travelata-libs/ui-kit';
    import { ConfirmationType } from '../lib/types';
    import getConfirmationTypeAdditionals from '../lib/getConfirmationTypeAdditionals';

    interface ConfirmationTypeTooltip {
        type?: ConfirmationType;
        color?: 'white' | 'black',
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationTypeAdditionals',
  props: {
    type: { default: undefined },
    color: { default: 'white' }
  },
  setup(__props: any) {

const props = __props as { type: ConfirmationType, color: 'white' | 'black' }

    

    const additionals = computed(() => getConfirmationTypeAdditionals(props.type)); 


return { __sfc: true,props, additionals, Icon, Typo }
}

})